import React from 'react'

export default function PrivacyPloicy() {
  return (
    <>
   
    <div className="container py-4 px-3">
        <h1>Privacy Policy</h1>
  <p>PokerBaazi (“we”, “our”, or “us”) values your trust. This Privacy Policy explains how we collect, use, and safeguard your information when you use our free-to-play games and related services. By using our app or website, you agree and consent to the collection and use of your information as described below.</p>

  <h2>1. Information We Collect From You</h2>
  <p>When you use our free-to-play games, we may collect the following types of information from you:</p>
  <ul>
    <li><strong>Account Information:</strong> When you sign up, you provide us details such as your name, username, email address, phone number, age, and password.</li>
    <li><strong>Gameplay Information:</strong> We collect information about the games you play, your scores, achievements, participation in tournaments, and interactions with other players.</li>
    <li><strong>Device & Technical Information:</strong> We automatically collect details such as your IP address, device type, operating system, browser type, and app usage data to help improve performance and security.</li>
    <li><strong>Cookies & Similar Technologies:</strong> When you visit our website or app, we may store cookies or similar files in your browser. Cookies help us personalize your experience, keep you signed in, manage game sessions, and enhance security. Advertisers on our platform may also use their own cookies, which are subject to their privacy policies.</li>
    <li><strong>Voluntary Information:</strong> If you choose to use features like chat, referrals, surveys, or promotional campaigns, we may collect the information you provide.</li>
  </ul>

  <h2>2. How We Use Your Information</h2>
  <p>We use your information for the following purposes:</p>
  <ul>
    <li>To allow you to register, log in, and play free-to-play games.</li>
    <li>To personalize your gaming experience and improve our services.</li>
    <li>To provide customer support and respond to your queries.</li>
    <li>To send you updates, offers, rewards, and promotional content.</li>
    <li>To conduct analysis, surveys, and research to understand how players use our games.</li>
    <li>To maintain the safety, security, and fairness of our platform.</li>
  </ul>

  <h2>3. Sharing of Information</h2>
  <p>We respect your privacy and do not sell your personal data. However, we may share your information with:</p>
  <ul>
    <li><strong>Service Providers:</strong> Third parties that help us operate our games, send communications, or analyze performance.</li>
    <li><strong>Advertising Partners:</strong> For showing relevant ads, if you choose to allow personalized advertising.</li>
    <li><strong>Legal Authorities:</strong> If required by law, regulation, or government request.</li>
  </ul>

  <h2>4. Your Choices and Consent</h2>
  <p>By using our games, you consent to the collection and use of your information as explained in this Privacy Policy. At the same time, you are in control of your data and have the following choices:</p>
  <ul>
    <li><strong>Cookies:</strong> You can disable cookies in your browser or device settings. Please note that some features may not work properly if cookies are disabled.</li>
    <li><strong>Marketing & Notifications:</strong> You can opt out of marketing emails, SMS, or push notifications at any time.</li>
    <li><strong>Access, Correction, or Deletion:</strong> You may request access to, correction of, or deletion of your personal information at any time.</li>
  </ul>
  <p>All of the above requests can be exercised by sending us an email at <a href="mailto:playerrelation@pokerbaazi.com">playerrelation@pokerbaazi.com</a>.</p>

  <h2>5. Security of Your Information</h2>
  <p>We use reasonable safeguards to protect your information from unauthorized access, misuse, or loss. However, no system is 100% secure, so we encourage you to protect your account credentials.</p>

  <h2>6. Updates to This Policy</h2>
  <p>We may update this Privacy Policy from time to time. Any significant changes will be notified to you within the app or via email. Your continued use of our services means you accept the updated policy.</p>

    </div>
    </>
  )
}
